import { cn } from '@neo/lib/utils'
import { Typography } from '@neo/primitives/typography'

interface FormSectionHeaderProps {
  title: string
  subtitle?: string
  subtitleNode?: React.ReactNode
  className?: string
}

export const FormSectionHeader = ({
  title,
  subtitle,
  subtitleNode,
  className,
}: FormSectionHeaderProps) => (
  <div className={cn(className)}>
    <Typography variant="P/600">{title}</Typography>
    {subtitle && (
      <Typography variant="P/400" className="text-secondary">
        {subtitle}
      </Typography>
    )}
    {subtitleNode && (
      <Typography variant="P/400" className="text-secondary">
        {subtitleNode}
      </Typography>
    )}
  </div>
)
